import { AfterViewInit, Component, forwardRef, Host, Input, OnInit, Optional, SkipSelf } from '@angular/core';
import { ControlContainer, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { eanValidator } from '@app/form/validators/ean.validator';
import { BaseInput } from '../base-input';
import { Role } from '@core/enums';
import { Position } from '@core/enums/position';

@Component({
    selector: 'app-ean-code-input',
    template: `
        <app-label-container
            [required]="required"
            [id]="id"
            [label]="label"
            [hasMargin]="hasMargin"
            [hasMarginDouble]="hasMarginDouble"
            [labelTemplateRef]="eanCodeHeader"
        >
            <mat-form-field floatLabel="never" appearance="outline">
                <input
                    [id]="id"
                    type="text"
                    matInput
                    #input
                    name="eanCode"
                    [(ngModel)]="innerModel"
                    (blur)="onBlur($event)"
                    (ngModelChange)="onModelChange()"
                    [disabled]="innerDisabled"
                    [placeholder]="placeholder"
                    [errorStateMatcher]="errorStateMatcher"
                    autocomplete="smooved"
                    maxlength="18"
                />
                <mat-error *ngIf="getAbstractControl()?.invalid && (controlContainer?.['submitted'] || getAbstractControl()?.touched)"
                    >{{ getFirstErrorState() | errorState }}
                </mat-error>
            </mat-form-field>
        </app-label-container>

        <ng-template #eanCodeHeader>
            <div class="u-margin-bottom-half u-flex-row u-flex-justify-content-space-between">
                <label [for]="id">{{ label | translate }}</label>
                @if (verifiedBySmooved) {
                    <lib-verified-by-smooved [role]="Role.RealEstateAgent" [aligned]="Position.Right"></lib-verified-by-smooved>
                }
            </div>
        </ng-template>
    `,
    styleUrls: ['./ean-code-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => EanCodeInputComponent),
            multi: true,
        },
    ],
})
export class EanCodeInputComponent extends BaseInput implements ControlValueAccessor, OnInit, AfterViewInit {
    @Input() public id: string;
    @Input() public label: string = 'V2.SERVICES.METER_READINGS.UPDATE.EAN_CODE.LABEL';
    @Input() public placeholder: string;
    @Input() public formControlName: string;
    @Input() public autoFocus = false;
    @Input() public hasMargin = true;
    @Input() public hasMarginDouble = false;
    @Input() public verifiedBySmooved = false;

    public innerModel: string;

    protected readonly Role = Role;

    constructor(@Optional() @Host() @SkipSelf() controlContainer: ControlContainer) {
        super(controlContainer);
    }

    public onBlur(event: any): void {
        this.getAbstractControl().markAsTouched();
    }

    public ngOnInit(): void {
        super.ngOnInit();
        this.getAbstractControl().addValidators([eanValidator]);
    }

    public ngAfterViewInit(): void {
        super.ngAfterViewInit();
    }

    public writeValue(value: string): void {
        this.innerModel = value;
    }

    public onModelChange() {
        this.propagateChange(this.innerModel);
    }

    protected readonly Position = Position;
}
